/**
 * Get item from localStorage and parse it as JSON
 * @param {string} key - The key to get from localStorage
 * @param {any} defaultValue - Default value if key doesn't exist or parsing fails
 * @returns {any} Parsed value or defaultValue
 */
export const getLocalStorageItem = (key, defaultValue = null) => {
  try {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    return defaultValue;
  }
};

/**
 * Set item in localStorage after stringifying
 * @param {string} key - The key to set in localStorage
 * @param {any} value - The value to stringify and store
 * @returns {boolean} Success status
 */
export const setLocalStorageItem = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Remove item from localStorage
 * @param {string} key - The key to remove from localStorage
 * @returns {boolean} Success status
 */
export const removeLocalStorageItem = (key) => {
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
};

export const clearLocalStorage = () => {
  removeLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS);
  removeLocalStorageItem(LOCAL_STORAGE_KEYS.PERSIST);
  removeLocalStorageItem(LOCAL_STORAGE_KEYS.REFRESH);
  removeLocalStorageItem(LOCAL_STORAGE_KEYS.USERNAME);
  removeLocalStorageItem(LOCAL_STORAGE_KEYS.LOGLEVEL);
  window.localStorage.clear();
};

// Constants for localStorage keys
export const LOCAL_STORAGE_KEYS = {
  ACCESS: "access",
  REFRESH: "refresh",
  USERNAME: "username",
  PERSIST: "persist:root",
  LOGLEVEL: "loglevel",
  PENDING_MEMBER_INVITATION: "pendingMemberInvitation",
};
